import { IconButton, makeStyles, Tooltip } from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import React, { useContext } from 'react';
import styles from 'assets/jss/material-dashboard-pro-react/components/tasksStyle.js';
import { Row } from 'react-table';
import { useNavigate } from 'react-router-dom';
import { itemRoutes } from '../constants';
import { ClientServiceContext as Context } from '../context/ClientServiceProvider';
import ActionModal from '@components/Modal/ActionModal';
import { useDeleteClientExclusiveServiceMutation } from '../mutations';
import HoverDropdown from '@components/CustomDropdown/HoverDropdown';


interface IProps {
  row: Row;
}

// @ts-ignore
const useStyles = makeStyles(styles);
const TableActions: React.FC<IProps> = ({ row, ...rest }) => {
  const classes = useStyles();
  const history = useNavigate();
  const { refetchItems: refetch } = useContext(Context);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const { mutation: deleteItem } = useDeleteClientExclusiveServiceMutation({
    onComplete: () => {
      refetch && refetch();
      setIsModalOpen(false);
    },
  });

  return (
    <div className='actions-right' style={{ display: 'flex' }}>
      <Tooltip
        id='expander'
        onClick={() => {
          history(itemRoutes.getEditLink(row.values['node._id']));
        }}
        title='Edit'
        placement='top'
        classes={{ tooltip: classes.tooltip }}
      >
        <IconButton
          id='expander'
          aria-label='Edit'
          className={classes.tableActionButton}
        >
          <Edit
            className={classes.tableActionButtonIcon + ' ' + classes.edit}
          />
        </IconButton>
      </Tooltip>
      <Tooltip
        title='Delete'
        placement='top'
        classes={{ tooltip: classes.tooltip }}
      >
        <IconButton
          id='expander'
          aria-label='Delete'
          className={classes.tableActionButton}
          onClick={() => {
            setIsModalOpen(true)
          }}
        >
          <Delete
            className={classes.tableActionButtonIcon + ' ' + classes.edit}
          />
        </IconButton>
      </Tooltip>
      <HoverDropdown
        menus={[
          {
            name: 'Edit Permissions',
            props: rest,
            action: () => { }
          },
        ]} />
      <ActionModal
        isModalOpen={isModalOpen}
        toggleModal={setIsModalOpen}
        handleOnClickOkey={() =>
          deleteItem({
            variables: { clientExclusiveServiceId: row.values['node._id'] },
          })
        }
        handleOnClickCancel={() => setIsModalOpen(false)}
        okText='Delete'
      >
        <div>Are you sure you want to delete this client service?</div>
      </ActionModal>
    </div>
  );
};

export default TableActions;
